import React from 'react';

const OuterLayout = ({ children }) => {
    return <>{children}</>;
};

export default OuterLayout;
